import { type DevScenarioEntry, devScenarioEntry, mockApiError } from '@arya/shared/msw-cloudflare';

const INVEST = { method: 'POST', path: '/api/market/projects/:projectId/invest' } as const;
const INVEST_SCREEN = '/market/projects/2?invest=2500';

const investRefusal = (name: string, title: string, description: string, answer: () => Response): DevScenarioEntry =>
  devScenarioEntry({ name, group: 'Invest', title, description, screen: INVEST_SCREEN }, INVEST, answer);

export const INVEST_REFUSALS: readonly DevScenarioEntry[] = [
  investRefusal('invest-409', 'Duplicate', 'Confirming an investment answers 409: the same reservation exists.', () =>
    mockApiError(409, 'Duplicate reservation')
  ),
  investRefusal(
    'invest-blocked',
    'Account blocked',
    'Confirming an investment answers 403: the account cannot invest.',
    () => mockApiError(403, 'Account cannot invest')
  ),
  investRefusal(
    'invest-residence',
    'Residence not served',
    'Confirming an investment is refused: the country of residence is not served.',
    () => mockApiError(403, 'Residence not served', { reason: 'RESIDENCE_NOT_SERVED' })
  ),
  investRefusal(
    'invest-below-minimum',
    'Below the minimum',
    'Confirming an investment answers 400: the amount is under the project minimum (EUR 5,000).',
    () => mockApiError(400, 'Below minimum', { code: 'INVESTMENT_BELOW_MINIMUM', limitMinor: '500000' })
  ),
];
